import React from 'react'
import './index.scss'

type TListSortType = 'timeAsc' | 'timeDes' | 'balanceAsc' | 'balanceDes'

interface IProps {
  sort: TListSortType;
  onSortChange: (sort: TListSortType) => void;
}

const CardSort: React.FC<IProps> = ({ sort, onSortChange }) => {
  const handleChangeSort = (type: string) => () => {
    if (type === 'balance') {
      onSortChange(sort === 'balanceDes' ? 'balanceAsc' : 'balanceDes')
    } else {
      onSortChange(sort === 'timeDes' ? 'timeAsc' : 'timeDes')
    }
  }

  const sortType = sort?.replace(/Asc|Des/, '') || ''
  const sortMethod = sort?.replace(/balance|time/, '')?.toLocaleLowerCase() || ''
  return (
    <div className='gift-sort-header'>
      <div
        data-cypid='mmgSortGCardByBalance'
        className='gift-sort-header-tab'
        onClick={handleChangeSort('balance')}
      >
        <div className={`gift-sort-header-tab-text${sortType === 'balance' ? ' gift-sort-header-tab-text-active' : ''}`}>{i18n.t('mkt.giftCard.sortByBalance')}</div>
        <div className={`gift-sort-header-tab-icon${sortType === 'balance' ? ` gift-sort-header-tab-icon-${sortMethod}` : ''}`} />
      </div>
      <div
        data-cypid='mmgSortGCardByTime'
        className='gift-sort-header-tab'
        onClick={handleChangeSort('time')}
      >
        <div className={`gift-sort-header-tab-text${sortType === 'time' ? ' gift-sort-header-tab-text-active' : ''}`}>{i18n.t('mkt.giftCard.sortByTime')}</div>
        <div className={`gift-sort-header-tab-icon${sortType === 'time' ? ` gift-sort-header-tab-icon-${sortMethod}` : ''}`} />
      </div>
    </div>
  )
}

export default CardSort
